import { Screen } from '@fans-fund-me/shared-comm-react-cosmos/fans-fund-me/register-waitlist-screen';

function ServerError() {
  return <Screen />;
}
export default ServerError;
